<template>
  <v-app id="checkout">
    <v-container class="pa-0" fluid @mouseleave="onLeave">
      <section>
        <v-parallax
          id="imgHeader"
          class="grey"
          gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
          height="100"
          src="/img/certificacao-online-03.jpg"
        >
          <v-layout align-center column justify-center>
            <a class="ma-1" href="/">
              <v-img
                :aspect-ratio="16 / 9"
                class="pa-4"
                height="80"
                src="/img/logo/ls-h-branco.svg"
                width="250"
              ></v-img>
            </a>
          </v-layout>
          <v-layout align-center class="black--text" column justify-center>
          </v-layout>
        </v-parallax>
      </section>
      <v-container class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex lg8 md8 sm12 xs12>
            <v-container class="mx-auto pb-0 mb-0">
              <div id="left-side" v-bind:class="{ blocked: closing }">
                <v-stepper
                  v-model="step"
                  alt-labels
                  class="v-card--flat pb-0 mb-0"
                >
                  <v-stepper-header v-if="step !== 3" style="box-shadow: none">
                    <v-stepper-step :complete="step > 1" step="1"
                      >Identificação</v-stepper-step
                    >
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step > 2" step="2"
                      >Pagamento</v-stepper-step
                    >
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step > 3" step="3"
                      >Confirmação</v-stepper-step
                    >
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content class="pt-0" step="1">
                      <v-card
                        :loading="this.closing || this.loading"
                        class="mb-1 pt-0 pl-2 pr-2 pb-0 mb-0"
                        color="lighten-1"
                        flat
                      >
                        <login-form
                          v-if="!authenticated"
                          hide-remember="true"
                          redirect=""
                        >
                        </login-form>
                        <profile-form
                          v-else
                          :model="user"
                          submit-label="Avançar"
                          @submit="gotoPaymentStep"
                        ></profile-form>

                        <v-card-actions class> </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content class="pt-0" step="2">
                      <div
                        v-if="this.order.net_amount > 0"
                        id="BodyPaymentMethods"
                      >
                        <v-flex class="py-2" sm12 xs12>
                          <v-card class="mt-0 mt-0" flat> </v-card>
                          <!--</v-layout>-->
                        </v-flex>
                      </div>
                      <v-card
                        id="navButtons"
                        :loading="this.closing || this.loading"
                        class="pa-0 mt-5"
                        flat
                      >
                        <v-card-actions>
                          <v-btn depressed text @click="step = 1">Voltar</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-show="this.order.net_amount === 0"
                            :disabled="this.closing"
                            :loading="this.closing"
                            color="success"
                            large
                            ma-1
                            @click.prevent="redeemFullCoupon()"
                          >
                            <v-icon left>card_giftcard</v-icon>
                            Resgatar meu Cupom
                          </v-btn>
                          <form v-if="!this.hidePaymentButton" id="btnPagar">
                            <!--
                                                        <script defer
                                                                src="https://www.mercadopago.com.br/integrations/v1/web-payment-checkout.js"
                                                                type="application/javascript"
                                                                v-bind:data-button-label="this.$vuetify.breakpoint.mdAndDown ? 'Pagamento' : 'Escolher Pagamento'"
                                                                v-bind:data-preference-id="preference.id"
                                                        >
                                                        </script>
                            -->
                          </form>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content class="pt-0" step="3">
                      <m-p-thankyou :order="this.order"></m-p-thankyou>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </div>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <div
              id="summary"
              :class="this.$vuetify.theme.isDark ? 'dark' : undefined"
            >
              <order-summary
                :coupon-enabled="step !== 3"
                :order="this.order"
                @couponApplied="onCouponApplied"
              ></order-summary>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <exit-intent-dialog
      :show="this.showExitIntentDiaglog"
      @close="onCloseExitIntent"
    ></exit-intent-dialog>
  </v-app>
</template>
<script>
import OrdersServices from "../../services/orders.service";
import TransactionServices from "../../services/transactions.service";
import UserService from "@/services/users.service";
import OrderSummary from "./OrderSummary";
import LoginForm from "../../components/widgets/form/LoginForm";
import { mapGetters } from "vuex";
import LoggedForm from "../../components/widgets/form/LoggedForm";
import ProfileForm from "../../components/widgets/form/ProfileForm";
import ExitIntentDialog from "../../components/widgets/dialog/ExitIntentDialog";
import Cookies from "js-cookie";
import { waitForElement } from "../../util";
import MPThankyou from "./MPThankyou";

export default {
  components: {
    MPThankyou,
    ExitIntentDialog,
    ProfileForm,
    LoggedForm,
    LoginForm,
    OrderSummary,
  },
  data() {
    return {
      hidePaymentButton: false,
      preference: null,
      showChargeButton: true,
      transaction: null,
      step: 1,
      order: {
        items: {
          data: [],
        },
      },
      haveCoupon: false,
      code: "",
      closing: false,
      loading: true,
      showExitIntentDiaglog: false,
    };
  },
  created() {
    // window.onmouseout = this.leaving
  },
  mounted() {
    this.loadOrder();
  },
  metaInfo() {
    return {
      title: "LS - Cursos de Certificações Disponíveis",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Todos os cursos de certificação disponíveis do Prof Lucas Silva. CPA-10, CPA-20, CEA, CFP, ANCORD, HP",
        },
      ],
    };
  },
  computed: mapGetters({
    user: "authUser",
    authenticated: "authCheck",
  }),
  methods: {
    mercadoPagoInit: function (preferenceId) {
      this.loading = true;
      console.log("loading set true on init");
      const el = window.document.getElementById("btnPagar");
      el.innerHTML = "";
      const btnMpPayment = document.createElement("script");
      btnMpPayment.setAttribute(
        "src",
        "https://www.mercadopago.com.br/integrations/v1/web-payment-checkout.js",
      );
      btnMpPayment.setAttribute("data-preference-id", preferenceId);
      const cta = this.$vuetify.breakpoint.mdAndDown
        ? "Pagamento"
        : "Escolher Pagamento";
      btnMpPayment.setAttribute("data-button-label", cta);
      el.appendChild(btnMpPayment);
      /*
            const btn = window.document.querySelector('.mercadopago-button')
            console.log('button: ', btn)
            this.step = 2
            console.log('setp 2')
      */
      this.step = 2;
      const self = this;
      waitForElement(".mercadopago-button").then(function (element) {
        // element.setAttribute('class', 'v-btn v-btn--contained theme--light v-size--large success')
        self.$nextTick(function () {
          element.click();
          self.$vuetify.goTo(0);
          console.log("next");
          self.loading = false;
        });
      });
    },
    createPayment(coupon = false) {
      if (this.order.net_amount === 0) {
        this.loading = false;
        return;
      }
      this.loading = true;
      const _this = this;
      UserService.updateProfile(this.user)
        .then((response) => {
          OrdersServices.updateOrder(_this.order.id).then((response) => {
            if (_this.preference === null || coupon === true) {
              TransactionServices.createMercadoPagoPayment(
                _this.order.id,
                _this.user.id,
              )
                .then((response) => {
                  _this.preference = response.data;
                  _this.mercadoPagoInit(this.preference.id);
                })
                .catch((ex) => {
                  window.getApp.sendSnackMessage(ex.message, "error");
                  _this.loading = false;
                });
            } else _this.loading = false;
          });
        })
        .catch((ex) => {
          window.getApp.sendSnackMessage(ex.message, "error");
          this.loading = false;
          this.step = 1;
        });
    },
    loadOrder() {
      this.loading = true;
      const promises = [];
      let orderId = this.$route.params.orderId;
      // console.log(this.$route.query)
      if (this.$route.query.external_reference) {
        orderId = this.$route.query.external_reference;
      }
      promises.push(OrdersServices.getOrder(orderId));

      Promise.all(promises)
        .then((response) => {
          // console.log('order status: ----', response)
          this.order = response[0].data;
          // console.log('order status: ----', response[0].data)
          if (this.$route.query.external_reference) {
            /*
                          this.preference = response[1].data
                          console.log('Preference', this.preference)
              */
            this.step = 3;
            this.setAnalyticsActionCheckout(this.order, 3);
            this.createFacebookPurchase(this.order);
            this.createAnalyticsPurchase(this.order);
            this.loading = false;
          } else {
            this.createFacebookInitiateCheckout(this.order);
            this.setAnalyticsActionCheckout(this.order, 1);
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log("order error: ----", error.message);
          this.loading = false;
        });
    },
    gotoPaymentStep() {
      // console.log('Order: ', this.order, this.user)
      this.loading = true;
      if (this.order.user) {
        if (this.order.user.id !== this.user.id) {
          console.warn("Usuario logado diferente do usuário do pedido");
          OrdersServices.resetCoupon(this.$route.params.orderId).then(
            (response) => {
              this.order = response.data;
              this.loading = false;
            },
          );
        }
      }
      // this.updateProfile(this.user)
      this.createFacebookAddToCartCheckout(this.order);
      this.setAnalyticsActionCheckout(this.order, 2);
      this.createPayment();
      this.step = 2;
      this.$vuetify.goTo(0);
    },
    redeemFullCoupon() {
      OrdersServices.redeemFullProductCoupon(this.order.id)
        .then((res) => {
          this.transaction = {
            gateway: "gratis",
            id: null,
            installments: "1",
            net_amount: "Grátis",
            order_id: this.order.id,
            payment_method_id: null,
          };
          this.step = 3;
        })
        .catch((error) => {
          window
            .getApp()
            .sendSnackMessage("Problema ao resgatar o produto", "error");
        });
    },
    onCouponApplied(order) {
      this.order = order;
      // console.log(order)
      if (order.net_amount === 0) {
        this.hidePaymentButton = true;
        this.redeemFullCoupon();
      } else {
        if (this.authenticated) {
          this.createPayment(true);
        }
      }
      window.getApp.sendSnackMessage(
        `Cupom aplicado com sucesso! 💰`,
        "success",
      );
    },
    onLeave(e) {
      // console.log(e)
      if (e.clientY < 1 && this.step < 3) {
        console.log("Fugiu");
        if (!Cookies.get("IseeShark")) {
          console.log(Cookies.get("IseeShark"));
          Cookies.set("IseeShark", "1", { expires: 7 });
          this.showExitIntentDiaglog = true;
        }
      }
    },
    onCloseExitIntent() {
      console.log("fechou");
      this.showExitIntentDiaglog = false;
    },
    getFbCheckoutObject(course) {
      return {
        value: course.price,
        currency: "BRL",
        content_type: "product",
        contents: [
          {
            id: course.id,
            quantity: 1,
          },
        ],
      };
    },
    createFacebookInitiateCheckout(order) {
      const course = order.items.data[0].saleable;
      // const eventCourse = 'InitiateCheckout-' + course.id
      window.fbq("track", "InitiateCheckout", this.getFbCheckoutObject(course));
      // window.fbq('trackCustom', eventCourse, { value: course.price, currency: 'BRL' })
    },
    createFacebookAddToCartCheckout(order) {
      const course = order.items.data[0].saleable;
      // const eventCourse = 'AddPaymentInfo-' + course.id
      window.fbq("track", "AddToCart", this.getFbCheckoutObject(course));
      // window.fbq('trackCustom', eventCourse, { value: course.price, currency: 'BRL' })
    },
    createFacebookPurchase(order) {
      const course = order.items.data[0].saleable;
      // const eventPaymentMethod = 'Purchase-' + this.paymentMethod
      // const eventCourse = 'Purchase-' + course.id
      window.fbq("track", "Purchase", this.getFbCheckoutObject(course));
      // window.fbq('trackCustom', eventCourse, { value: course.price, currency: 'BRL' })
      // window.fbq('trackCustom', eventPaymentMethod, { value: course.price, currency: 'BRL' })
    },
    createAnalyticsPurchase(order) {
      // fbq('track', 'Purchase', {value: (data.amount / 100), currency: 'BRL'});
      const course = order.items.data[0].saleable;
      this.setAnalyticsProduct(order);
      let coupon = "";
      if (order.coupon_id) coupon = order.coupon_id.toString();
      this.$ga.ecommerce.setAction("purchase", {
        id: order.id.toString(),
        affiliation: "",
        revenue: course.price,
        tax: "0.00",
        shipping: "0.00",
        coupon: coupon,
      });
      this.$ga.page(this.$router);
    },
    setAnalyticsActionCheckout(order, stepNumber, option = "") {
      // fbq('track', 'Purchase', {value: (data.amount / 100), currency: 'BRL'});
      this.setAnalyticsProduct(order);
      if (stepNumber === 1) {
        this.$ga.ecommerce.setAction("add");
      }
      this.$ga.ecommerce.setAction("checkout", {
        step: stepNumber,
        option: option,
      });
      this.$ga.page(this.$router);
    },
    setAnalyticsProduct(order) {
      const course = order.items.data[0].saleable;
      this.$ga.ecommerce.addProduct({
        id: order.id, // Transaction ID. Required.
        name: course.course, // Product name. Required.
        sku: course.id, // SKU/code.
        category: "Videoaula", // Category or variation.
        price: course.price, // Unit price.
        quantity: "1", // Quantity.
      });
    },
  },
};
</script>

<style lang="css" scoped>
.blocked {
  pointer-events: none;
}

#summary.dark {
  background-color: #212121 !important;
}
#summary {
  height: calc(100vh - 100px);
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-color: #f5f5f5 !important;
  background-size: cover;
  overflow: hidden;
  padding: 20px;
}

.v-stepper {
  box-shadow: none;
}

#left-side {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
  background-color: #ffffff !important;
  padding: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

@-webkit-keyframes swing {
  15% {
    -webkit-transform: translateX(15px);
    transform: translateX(15px);
  }
  30% {
    -webkit-transform: translateX(-15px);
    transform: translateX(-15px);
  }
  50% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  65% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
  80% {
    -webkit-transform: translateX(3px);
    transform: translateX(3px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@keyframes swing {
  15% {
    -webkit-transform: translateX(15px);
    transform: translateX(15px);
  }
  30% {
    -webkit-transform: translateX(-15px);
    transform: translateX(-15px);
  }
  50% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  65% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
  80% {
    -webkit-transform: translateX(3px);
    transform: translateX(3px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

/* Media query for mobile viewport */
@media screen and (max-width: 400px) {
  #paypal-button-container {
    width: 100%;
  }
}

/* Media query for desktop viewport */
@media screen and (min-width: 400px) {
  #paypal-button-container {
    width: 230px;
  }
}
</style>
